const defaultCssName = "form-control"; //bootstrap

export const styles = {
    elements: {
        label: "form-label", //BS v5
        input: defaultCssName,
        select: "form-select",
        button: "btn",
        checkbox: {
            container: "form-check",
            input: "form-check-input",
            label: "form-check-label"
        }
    }
}

export default styles;